import React from "react";
import { Link } from "react-router-dom";

function WhychooseUs({ dataAbout }) {
  return (
    <div>
      <>
        {/* Start Work Area  */}
        <div className="work-area work-style-one tmp-section-gap">
          <div className="container">
            <div className="row">
              <div className="work-top-inner">
                <div className="section-head pb-0 section-head-one-side text-align-left">
                  <div className="section-sub-title color-white ">
                    <span className="subtitle">{dataAbout?.subtitle}</span>
                  </div>
                  <h2 className="title color-white split-collab">
                    {dataAbout?.title}
                  </h2>
                </div>
                <div
                  className="single-work-top"
                  data-sal-delay={250}
                  data-sal="slide-up"
                  data-sal-duration={800}
                >
                  <h2 className="title">{dataAbout?.SymbolName}</h2>
                  <div className="sub-title">{dataAbout?.SymbolDesc}</div>
                </div>
                <div className="scater-line">
                  <img src="assets/images/work/shape.png" alt="" />
                </div>
              </div>
            </div>
            <div className="row g-5">
              <div
                className="col-lg-5 col-md-5"
                data-sal-delay={150}
                data-sal="slide-up"
                data-sal-duration={800}
              >
                <div className="inner">
                  <a>
                    <div className="thumbnail">
                      <img
                        className="large"
                        src={dataAbout?.img}
                        alt="Business Consulting"
                      />
                    </div>
                  </a>
                </div>
              </div>

              <div className=" row col-lg-7 col-md-7">
                {dataAbout?.items?.map((item) => {
                  return (
                    <div
                      key={item.id}
                      className="row col-lg-5 col-md-6"
                      data-sal-delay={item.delay}
                      data-sal="slide-up"
                      data-sal-duration={800}
                    >
                      <div className="single-work style-one mt--30">
                        <Link to={`/detail_departement_${item.id}`}>
                          <div className="work-inner">
                            <div className="thumbnail">
                              <img
                                src="assets/images/work/consultation.png"
                                alt="Business Consulting"
                              />
                            </div>
                            <h3 className="title">{item.title}</h3>
                          </div>
                        </Link>
                      </div>
                    </div>
                  );
                })}
              </div>

              <div className="col-lg-12">
                <div className="work-inner">
                  <p className="description" style={{ color: "#ffffff" }}>
                    {dataAbout?.desc}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End Work Area  */}
      </>
    </div>
  );
}

export default WhychooseUs;
